import { useQuery } from '@tanstack/react-query';

import { DrugsApi } from '@/api/domains/drugs.api';
import { DrugsQueryKeys } from '@/api/domains/drugs.query-keys';

export const useInstructionForPharmacist = (drugId: number) =>
  useQuery({
    queryKey: DrugsQueryKeys.getInstructionForPharmacist(drugId),
    queryFn: async () => await DrugsApi.fetchInstructionForPharmacist(drugId),
    staleTime: Infinity,
    retry: false,
  });
